module.exports = __webpack_public_path__ + "img/labmanager-store.92cf8a02.svg";